import { render, staticRenderFns } from "./BottomInfo.vue?vue&type=template&id=3a21524e&scoped=true&"
import script from "./BottomInfo.vue?vue&type=script&lang=ts&"
export * from "./BottomInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BottomInfo.vue?vue&type=style&index=0&id=3a21524e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a21524e",
  null
  
)

export default component.exports